/*jshint esversion: 6 */
var loadGoogleMapsApi = require('load-google-maps-api-2');
import {mapStyles} from '../helpers';

class Contact {
    constructor(el) {
        this.el = el;
        
        this.el.map = this.el.find('#mapCanvas');
        this.el.contactOverview = this.el.find('.contact--overview');

        this.mapOpts = {
            zoom: 15,
            styles: mapStyles,
            panControl: false,
            mapTypeControl: false,
            scaleControl: false,
            scrollwheel: false,
            zoomControl: false,
            disableDefaultUI: true,
            center: {
                lat: 25.1873684,
                lng: 55.2589709
            }
        };
        

        this.initPlugins();
        this.windowResize();
        $(window).on('resize', this.windowResize.bind(this));

        window.smoothScrollInstances.push(this);
    }

    initPlugins() {
        const that = this;
        loadGoogleMapsApi({
            key: 'AIzaSyDkR7Of8YoZMGpGR3H7AHqcZFxGjKrXVLI'
        }).then(function (googleMaps) {
            var tentwentyMap = new googleMaps.Map(that.el.map[0], that.mapOpts);
            
            var image = {
                url: `${CCM_APPLICATION_URL}/application/themes/tentwenty/images/pin.png`,
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(25, 30)
              };

            var pin = new googleMaps.Marker({
                position: {
                    lat: 25.1873684,
                    lng: 55.2589709
                },
                icon: image,
                map: tentwentyMap,
                animation: googleMaps.Animation.DROP,
            });

            googleMaps.event.addListener(pin, 'click', function() {
                var win = window.open($('a[title=directions]').attr('href'), '_blank');
                win.focus();
            });

            // pin.setMap(tentwentyMap);

        }).catch(function (err) {
            alert('failed to load google maps. Please refresh your page.');
        });
    }

    windowResize() {
        this.el.map.height(window.innerHeight);
        this.el.contactOverview.height(window.innerHeight);
    }
    
    on() {
        super.on();
        $(window).on('resize', this.windowResize.bind(this));
    }

    off() {
        super.off();
        $(window).off('resize');
    }

    destroy() {
        $(window).off('resize');        
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./app/components/scrolling/contact-scroll.js